<nz-modal
  [nzVisible]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="footerTemplate ? null : modalFooterTemplate"
  [nzWidth]="width"
  nzCentered
  [nzClassName]="!iconSrc ? 'small-header-height' : ''"
  (nzOnCancel)="handleCancel()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div
        class="modal-icon"
        *ngIf="iconSrc"
        [ngClass]="'modal-icon-' + iconColor">
        <svg-icon [src]="iconSrc" class="icon s-20"> </svg-icon>
      </div>
      <h3 class="ant-modal-title">{{ title }}</h3>
      <!-- Message Section -->
      <p class="text s-14 fw-400 ant-modal-subtitle message" *ngIf="message">
        {{ message }}
      </p>
      <ng-container *ngIf="messageTemplate">
        <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
      </ng-container>

      <svg-icon
        *ngIf="iconSrc"
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern">
      </svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleCancel()">
        {{ cancelText }}
      </button>
      <button
        nz-button
        [nzType]="'primary'"
        [ngClass]="primaryButtonClass"
        [nzLoading]="loading"
        (click)="handleConfirm()">
        {{ confirmText }}
      </button>
    </div>
  </ng-template>
</nz-modal>
